import programing from "../../assets/img/home/programing.webp";
import youtube from "../../assets/img/home/youtube.webp";
// import cms from "../../assets/img/home/cms.webp";
import hosting from "../../assets/img/home/hosting.webp";
import learning from "../../assets/img/home/learning.webp";
import community from "../../assets/img/home/community.webp";
import ide from "../../assets/img/home/ide.webp";
import job from "../../assets/img/home/job.webp";
import challenge from "../../assets/img/home/challenge.webp";
import design from "../../assets/img/home/design.webp";
import newSticker from "../../assets/img/new.webp";



// Sticker New


export const Item1 = [
  {
    title: "Programming",
    path: "/programming",
    cName: "homeItem",
    img: programing,
    cNameImg: "imgItem",
    news: newSticker,
    id: 1,

  },
  {
    title: "Youtube Channel",
    path: "/youtube-channel",
    cName: "homeItem",
    img: youtube,
    cNameImg: "imgItem",
    id:2,
  },
  {
    title: "Learning",
    path: "/learning",
    cName: "homeItem",
    img: learning,
    cNameImg: "imgItem",
    id:3,
  },
  {
    title: "Éditeur / IDE",
    path: "/ide",
    cName: "homeItem",
    img: ide,
    cNameImg: "imgItem",
    id: 4
  },
];
export const Item2 = [
  {
    title: "Community",
    path: "/community",
    cName: "homeItem",
    img: community,
    cNameImg: "imgItem",
  },
  // {
  //   title: "CMS",
  //   path: "/cms",
  //   cName: "homeItem",
  //   img: cms,
  //   cNameImg: "imgItem",
  // },
  {
    title: "Hosting",
    path: "/hosting",
    cName: "homeItem",
    img: hosting,
    cNameImg: "imgItem",
  },

  {
    title: "Job Platform",
    path: "/job",
    cName: "homeItem",
    img: job,
    cNameImg: "imgItem",
  },
  {
    title: "Challenge",
    path: "/challenge",
    cName: "homeItem",
    img: challenge,
    cNameImg: "imgItem",
  },
];

export const Item3 = [
  {
    title: "Design",
    path: "/design",
    cName: "homeItem",
    img: design,
    cNameImg: "imgItem",
  },
];
